// Actions
import {
  SET_INTENDED_LEVEL_OF_STUDY,
  SET_ENTRY_TERM,
  SET_INTENDED_MAJOR,
  SET_GPA,
  SET_TEST_SCORES,
  SET_PROSPECT_PROFILE_STATE
} from "../actionTypes/prospectProfile.actionTypes";

// Classes
import { ProspectProfileReducerState } from "../classes/prospectProfile.classes";

const initialState = new ProspectProfileReducerState();

export const ProspectProfileReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_INTENDED_LEVEL_OF_STUDY:
      return { ...state, intendedLevelOfStudy: action.payload };
    case SET_ENTRY_TERM:
      return { ...state, entryTerm: action.payload };
    case SET_INTENDED_MAJOR:
      return { ...state, intendedMajor: action.payload };
    case SET_GPA: {
      return { ...state, gpa: action.payload };
    }
    case SET_TEST_SCORES:
      return { ...state, testScores: action.payload };
    case SET_PROSPECT_PROFILE_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
